/** Plain-language explanations for drivers (what a score area measures and how to raise it). */
import { msg } from '@/lib/i18n';

export const AREA: Record<string, { label: string; what: string }> = {
  acceleration: { label: msg('Pulling away'), what: msg('How smoothly you speed up. Hard acceleration lowers it.') },
  deceleration: { label: msg('Braking'), what: msg('How early and gently you brake. Harsh braking lowers it.') },
  steering: { label: msg('Cornering'), what: msg('How calmly you take bends. Sharp cornering lowers it.') },
  tailgating: { label: msg('Following distance'), what: msg('Keeping enough distance to the vehicle in front.') },
  speeding: { label: msg('Speed'), what: msg('Staying within the speed limit.') },
  eyes_closed: { label: msg('Tiredness'), what: msg('Signs of fatigue seen by the cabin camera.') },
  yawning: { label: msg('Yawning'), what: msg('Yawning seen by the cabin camera — a sign to take a break.') },
  focus: { label: msg('Attention'), what: msg('Eyes on the road, as seen by the cabin camera.') },
  phone_use: { label: msg('Phone'), what: msg('Not using a phone while driving.') },
  idling: { label: msg('Idling'), what: msg('Engine running while standing still. Switching off raises it.') },
  engine_load: { label: msg('Engine load'), what: msg('Driving in an efficient part of the engine’s range.') },
  cruise_control: { label: msg('Cruise control'), what: msg('Using cruise control where the road allows it.') },
  coasting: { label: msg('Rolling out'), what: msg('Letting the vehicle roll instead of braking late.') },
};

/** How a score reads, for a driver: 80+ very good, 70+ good, 60+ fair, 40+ needs attention, below 40 poor. */
export function scoreWords(v: number | null | undefined): string {
  if (v == null) return msg('Not enough driving to score');
  if (v >= 80) return msg('Very good');
  if (v >= 70) return msg('Good');
  if (v >= 60) return msg('Fair');
  if (v >= 40) return msg('Needs attention');
  return msg('Needs work');
}
